import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAuthToken, logout } from '../lib/auth';
import { supabase } from '../lib/supabase';
import { useTheme } from '../contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';
import '../App.css';
import WaitlistModal from './WaitlistModal';

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isDark, toggleTheme } = useTheme();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            const token = await getAuthToken();
            setIsAuthenticated(!!token);
        };
        checkAuth();

        // Listen to auth state changes
        const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
            setIsAuthenticated(!!session);
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const handleLogout = async () => {
        const success = await logout();
        if (success) {
            setIsAuthenticated(false);
            navigate('/signup');
        }
    };

    return (
        <header className="App-header">
            <div className="header-container">
                <div className="logo">
                    <Link to="/" className="logo-link">
                        <h1>Colorkarma Directory</h1>
                    </Link>
                </div>
                <nav className="nav-menu">
                    {!isAuthenticated && (
                        <>
                            <Link
                                className={`nav-link ${location.pathname === '/buyers' ? 'active' : ''}`}
                                to="/buyers"
                            >
                                For Buyers
                            </Link>
                            <Link
                                className={`nav-link ${location.pathname === '/suppliers' ? 'active' : ''}`}
                                to="/suppliers"
                            >
                                For Suppliers
                            </Link>
                            <Link
                                className={`nav-link ${location.pathname === '/clients' ? 'active' : ''}`}
                                to="/clients"
                            >
                                Our Clients
                            </Link>
                        </>
                    )}
                    {isAuthenticated && (
                        <>
                            <Link
                                className={`nav-link ${location.pathname === '/directory' ? 'active' : ''}`}
                                to="/directory"
                            >
                                Directory
                            </Link>
                            <Link
                                className={`nav-link ${location.pathname === '/matches' ? 'active' : ''}`}
                                to="/matches"
                            >
                                Matches
                            </Link>
                            <Link
                                className={`nav-link ${location.pathname === '/profile' ? 'active' : ''}`}
                                to="/profile"
                            >
                                Profile
                            </Link>
                        </>
                    )}
                    {isAuthenticated ? (
                        <button
                            type="button"
                            className="header-btn-logout"
                            onClick={handleLogout}
                        >
                            Logout
                        </button>
                    ) : (
                        <Link to="/login" className="header-cta-login">
                            Log In
                        </Link>
                    )}
                    {!isAuthenticated && (
                        <button type="button" className="btn-primary" onClick={() => setIsWaitlistModalOpen(true)}>Join the Waitlist</button>
                    )}
                    <button
                        type="button"
                        onClick={toggleTheme}
                        className="theme-toggle"
                        aria-label="Toggle dark mode"
                    >
                        {isDark ? (
                            <Sun size={20} />
                        ) : (
                            <Moon size={20} />
                        )}
                    </button>
                </nav>
            </div>
            <WaitlistModal isOpen={isWaitlistModalOpen} onClose={() => setIsWaitlistModalOpen(false)} />
        </header>
    );
};

export default Header;
